<template>
  <span :key="getFlag">{{ getdata }}</span>
</template>
<script>

import { mapGetters } from "vuex";
export default {
  name: "ChangeLanguageComponent",
  props: ["langName"],
  computed: {
    ...mapGetters(["getFlag"]),
    getdata(){
      for (const key in this.langName) {
        if (this.langName.hasOwnProperty(key)) {
          if (key === this.getFlag) {
            return this.langName[key]
          }
        }
      }
    return this.langName["English"]
    },
  },
};
</script>
